<template>
  <templates-table @dataLoaded="setItems">
                <template slot="header_actions">
                        <schema-form
                                :method="method"
                                :external-model="model"
                                @stored="reloadTable"
                                @close="model = null"
                                :shouldBeOpened="shouldBeOpened()"
                        ></schema-form>
                  <import-patient-dialog ref="import_patient_dialog" @schemaSelected="schemaSelectedForImport"/>
                  <menu-scale-modal ref="menuScaleModal"></menu-scale-modal>
                </template>

                <template slot="table-actions" slot-scope="props">
                    <v-layout align-center justify-end>
                        <icon-button
                            icon="person"
                            color="light-blue"
                            cls="mr-0 ml-0"
                            @click="openImportPatientDialog($event, props.item.id, props.item.desired_diet_energy)"
                            :tooltip="{top: true, bottom: false, attach: false}"
                            :iconOptions="{small: true}"
                            :permission="canImport(props.item)"
                        >
                          {{ 'app.import_schema_into_patient.import_button' | trans}}
                        </icon-button>

                        <icon-button
                            icon="launch"
                            color="light-blue"
                            cls="mr-0 ml-0"
                            :permission="(props.item.system && hasPermission('schema_system_show')) || (!props.item.system && hasPermission('schema_show'))"
                            :href="`/schemas/${props.item.id}`"
                            :tooltip="{top: true, bottom: false, attach: false}"
                            :iconOptions="{small: true}"
                        >
                          {{ 'app.open' | trans}}
                        </icon-button>

                        <icon-button
                            icon="edit"
                            color="success"
                            cls="mr-0 ml-0"
                            v-if="canEdit(props.item)"
                            permission="schema_edit"
                            @click="editItem(props.item)"
                            :tooltip="{top: true, bottom: false, attach: false}"
                            :iconOptions="{small: true}"
                        >
                          {{ 'app.edit' | trans}}
                        </icon-button>

                        <icon-button
                                @click="copy(props.item)"
                                icon="file_copy"
                                color="light-blue"
                                cls="mr-0 ml-0"
                                :permission="canCopy(props.item)"
                                :tooltip="{top: true, bottom: false, attach: false}"
                                :iconOptions="{small: true}"
                        >
                            {{ 'app.copy' | trans}}
                        </icon-button>

                        <icon-button
                                v-if="props.item.shared === false"
                                @click="favorite(props.item)"
                                :icon="props.item.favorited ? 'favorite' : 'favorite_border'"
                                color="amber"
                                cls="mr-0 ml-0"
                                :permission="`schema_favorite`"
                                :tooltip="{top: true, bottom: false, attach: false}"
                                :iconOptions="{small: true}"
                        >
                            {{ props.item.favorited ? 'app.favorited' : 'app.add_to_favorites' | trans }}
                        </icon-button>

                        <icon-button
                                icon="delete"
                                color="red"
                                cls="mr-0 ml-0"
                                v-if="displayDelete(props.item)"
                                :permission="canDelete(props.item)"
                                @click="deleteItem(props.item)"
                                :tooltip="{top: true, bottom: false, attach: false}"
                                :iconOptions="{small: true}"
                        >
                            {{ 'app.delete' | trans}}
                        </icon-button>
                    </v-layout>
                </template>
            </templates-table>
</template>

<script>
  import { trans } from '../../app';
  import { mapGetters, mapState } from 'vuex';

  export default {

    data: () => ({
      items: [],
      model: null,
      errors: {
        title: {
          state: false,
          message: '',
        },
        desired_diet_energy: {
          state: false,
          message: '',
        },
      },
      mode: 'create',
      schemaIdToEdit: null
    }),
    computed: {
      ...mapState(['dictionaries']),
      ...mapGetters(['hasPermission']),

      method() {
        return this.mode === 'create' ? 'POST' : 'PATCH';
      },
    },

    methods: {
      openImportPatientDialog(event, schemaId, desiredDietEnergy) {
        this.schemaIdToEdit = schemaId;
        this.$refs.import_patient_dialog.open(schemaId, desiredDietEnergy);
      },
      setItems(payload) {
        const { data } = payload;
        this.items = data;
      },
      redirect(url) {
        window.location = url;
      },

      async favorite(item) {
        await axios.patch(`/schemas/${item.id}/favorite`);

        item.favorited = !item.favorited;
        this.$toast(item.favorited ? trans('app.added_to_favorites') : trans('app.removed_from_favorites'));
      },

      editItem(item) {
        this.model = this.items.find(i => i.id === item.id);
      },

      async deleteItem(item) {
        const confirm = await this.$confirm(
          trans('app.confirm_template_removal', {name: item.title, kcal: item.desired_diet_energy}),
          {
            title: trans('app.remove') + ' ' + trans('page.schemas.schema').toLowerCase(),
          },
        );

        if (confirm) {
          try {
            await axios.delete('/schemas/' + item.id);
          } catch (e) {
            if (e.response
                && e.response.status
                && +e.response.status === 404) {
              this.$toast.error(trans('app.menu_schema_does_not_exist'));
              this.reloadTable();

              return;
            }
            this.sentryCaptureException(e);
          }

          this.items.splice(this.items.indexOf(item), 1);
          this.reloadTable();
          this.$toast(trans('app.actions.removed', {name: trans('app.schema').toLowerCase()}));
        }
      },

      reloadTable() {
        this.$root.$emit('reloadTable');
      },

      async copy(item) {

        await axios.post(`/schemas/${item.id}/copy`);
        this.reloadTable();
        this.$toast(trans('app.actions.copied', {name: trans('app.schema').toLowerCase()}));

      },
      shouldBeOpened() {
        const uri = window.location.search.substring(1);
        const params = new URLSearchParams(uri);

        return !!params.get("add");
      },
      canImport(schema) {
        if (schema.days > 7 && !this.hasPermission('menu_schema_31_days')) {
          return false;
        }
        return this.hasPermission('menu_schema_import') && ((schema.system && this.hasPermission('schema_system_show') || (!schema.system && this.hasPermission('schema_show'))));
      },
      canEdit(schema) {
        if (schema.days > 7 && !this.hasPermission('menu_schema_31_days')) {
          return false;
        }
        if (!schema.system && !schema.shared) {
          return true;
        }

        return schema.system && this.hasPermission('edit_system_schema');
      },
      canCopy(schema) {
        if (schema.days > 7 && !this.hasPermission('menu_schema_31_days')) {
          return false;
        }
        if (schema.system && this.hasPermission('schema_system_show')) {
          return true;
        }
        return !schema.system && this.hasPermission('schema_copy');
      },
      displayDelete(schema) {
        if (!schema.system && !schema.shared) {
          return true;
        }
        return schema.system && this.hasPermission('schema_system_delete');

      },
      canDelete(schema) {
        if (schema.days > 7 && !this.hasPermission('menu_schema_31_days')) {
          return false;
        }
        if (!schema.system && this.hasPermission('schema_delete')) {
          return true;
        }
        return schema.system && this.hasPermission('schema_system_delete');
      },
      schemaSelectedForImport(payload) {
        this.$refs.menuScaleModal.open(payload.patient_id, payload.schema_id, payload.desiredDietEnergy);
      }
    },
  };
</script>
<style type="text/scss" scoped lang="scss">
    .favorite__icon {
        transition: .3s color;

        &:hover {
            color: gold;
        }
    }
</style>
